export const POST_MAINTENANCE_SYSTEM_REQUEST = 'POST_MAINTENANCE_SYSTEM_REQUEST';
export const POST_MAINTENANCE_SYSTEM_REQUEST_SUCCESS = 'POST_MAINTENANCE_SYSTEM_REQUEST_SUCCESS';
export const POST_MAINTENANCE_SYSTEM_REQUEST_FAILURE = 'POST_MAINTENANCE_SYSTEM_REQUEST_FAILURE';